import {type AxiosRequestConfig} from 'axios';

import {spotheroGet} from 'api';
import {type ApiResponse} from 'api/api.types';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys, convertKeysToSnakeCase} from 'utils/format-strings';

import {
    type CompPassBatchesResponse,
    type CompPassBatchResults,
} from 'api/comp-passes/comp-pass.types';

interface SortingParams {
    page: number;
    perPage: number;
    orderBy?: string;
}

export interface GetCompPassActivityParams {
    facilityId: number;
    params: SortingParams;
    config?: AxiosRequestConfig;
}

/**
 * Formats the request parameters for getting comp pass activity.
 */
const formatRequestParams = (params: SortingParams) => {
    const formattedRequest = convertKeysToSnakeCase(params);

    return formattedRequest;
};

/**
 * Formats the response from getting comp pass activity.
 */
const formatGetCompPassActivityResponse = (
    response: ApiResponse<CompPassBatchesResponse>
): CompPassBatchResults => {
    const formattedData: CompPassBatchResults = camelizeKeys(response.data);

    return formattedData;
};

/**
 * Fetches comp pass activity for a given facility.
 *
 * @see '/api/v1/facilities/{facilityId}/comp-pass/batches/'
 */
export const getCompPassActivity = async ({
    facilityId,
    params,
    config = {},
}: GetCompPassActivityParams) => {
    try {
        const formattedParams = formatRequestParams(params);

        const response = await spotheroGet<CompPassBatchesResponse>(
            `facilities/${facilityId}/comp-pass/batches/`,
            formattedParams,
            config
        );

        const formattedResponse = formatGetCompPassActivityResponse(response);

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};
